import React, { useContext } from 'react';
import PageSectionContentTable from '../../common/PageSection/PageSectionContentTable';
import { CompanyContext } from '../Provider/CompanyProvider';
import companyDef from '../companyDef';

export default () => {
	const { company } = useContext(CompanyContext);
	return <PageSectionContentTable values={company} columnDefs={[companyDef.accountManager]} />;
};
